// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import DeleteShopPaymentRequestModel from '../../model/delete-shop-payment-request-model';
import DeleteShopPaymentRequestDTO from '../dto/delete-shop-payment-request-dto';
import dtoSchema from '../schemas/delete-shop-payment-request-schema';

export default abstract class DeleteShopPaymentRequestModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<DeleteShopPaymentRequestDTO>) {
    super();
    if (data) {
      this.id = data.id;
    }
  }
  /**
  * @type {int64}
  */
  id?: number;

  static toModel(dto: DeepPartial<DeleteShopPaymentRequestDTO>): DeleteShopPaymentRequestModel;
  static toModel(dto: DeepPartial<DeleteShopPaymentRequestDTO> | undefined | null): DeleteShopPaymentRequestModel | undefined;
  static toModel(dto: DeepPartial<DeleteShopPaymentRequestDTO> | undefined | null): DeleteShopPaymentRequestModel | undefined {
    return dto ? new DeleteShopPaymentRequestModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<DeleteShopPaymentRequestModel> | DeleteShopPaymentRequestModel): DeleteShopPaymentRequestDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      id: unwrapped.id,
    } as DeleteShopPaymentRequestDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for DeleteShopPaymentRequestModel, can not map to DeleteShopPaymentRequestDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
